// VDED11389 at 15/05/2015 02:59:56
var journeycode = 'E418250A-4532-4AEC-81BE-74DD5A0D70CA';
var captureConfigUrl = 'drs2.veinteractive.com/CaptureConfigService.asmx/CaptureConfig';
var chatServicesUrl = 'rcs.veinteractive.com/ConversationService.asmx/';
var veHostDomain = "//config1.veinteractive.com";

(function () {
    var tag = document.getElementById('veConnect');
    if (!tag) {
        var ve = document.createElement('script');
        ve.id = 'veConnect';
        ve.type = 'text/javascript';
        ve.async = true;
        ve.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'config1.veinteractive.com/tags/E418250A/4532/4AEC/81BE/74DD5A0D70CA/vecapture.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ve, s);
    }
})();